import gql from 'graphql-tag';

export default gql`
    query GetWellheadsByJobId($jobId: Int) {
        getWellheadsByJobId(jobId: $jobId) {
            wellHead
            stages
        }
    }
`;
